import React from 'react';
import { Alert, Box, List, ListItem, Typography } from '@mui/material';
import { ApiError } from '@/types/api';
import { ErrorService } from '@services/errorService';

interface ErrorDisplayProps {
  error: ApiError | null;
  onClose?: () => void;
  showDetails?: boolean;
}

export const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ 
  error, 
  onClose,
  showDetails = false
}) => {
  if (!error) return null;

  const hasValidationErrors = error.validationErrors && 
    Object.keys(error.validationErrors).length > 0;

  return (
    <Alert 
      severity="error" 
      onClose={onClose}
      sx={{ mb: 2 }}
    >
      {/* <AlertTitle>Erro - {error.code}</AlertTitle> */}
      <Typography>{ErrorService.getFormattedMessage(error)}</Typography>

      {hasValidationErrors && showDetails && (
        <Box mt={1}>
          <Typography variant="subtitle2">Detalhes dos erros:</Typography>
          <List dense>
            {Object.entries(error.validationErrors || {}).map(([field, detail]) => (
              <ListItem key={field}>
                <Typography variant="body2">
                  {detail.message}
                </Typography>
              </ListItem>
            ))}
          </List>
        </Box>
      )}

      {showDetails && error.details?.helpUrl && (
        <Typography variant="body2" mt={1}>
          <a href={error.details.helpUrl} target="_blank" rel="noopener noreferrer">
            Mais informações sobre este erro
          </a>
        </Typography>
      )}
    </Alert>
  );
}; 